import React, { useEffect, useState } from 'react'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
function Index() {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  const [totalUser, setTotalUser] = useState('0');
  const [activeUser, setActiveUser] = useState('0');
  const [recentUser, setRecentUser] = useState([]);
  const [recentDeposit, setrecentDeposit] = useState([]);
  const [recentWithdraw, setRecentWithdraw] = useState([]);
  const [totalDeposit, setTotalDeposit] = useState('0');
  const [totalWithdraw, setTotalWithdraw] = useState('0');
  const [tabelLoading, setTableLoading] = useState(false);
  const [walletData, setWalletData] = useState({})

  useEffect(() => {
    const fetchProfileData = async () => {
      //console.log('Token ', authToken);
      try {
        const statics = await fetch(`${baseurl}/statics`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (statics.status === 429) {
          //  console.error("Rate limit exceeded. Please try again later.");
          return; // Stop further processing
        }

        const staticResult = await statics.json();
        console.log('Static data', staticResult);

        if (staticResult.status) {
          setTotalUser(staticResult.total_user);
          setActiveUser(staticResult.active_user);
          setTotalDeposit(staticResult.total_deposit);
          setTotalWithdraw(staticResult.total_withdraw);
          setRecentUser(staticResult.recent_user);
          setrecentDeposit(staticResult.recent_deposit);
          setRecentWithdraw(staticResult.recent_withdraw)
          setWalletData(staticResult.data);

          setTableLoading(true);
        } else {
          // Handle any error condition
          setTableLoading(true);
        }

      } catch (error) {
        //  console.error('Fetch error:', error);
        setTableLoading(true);
      }
    };

    fetchProfileData();
  }, []);


  const handleProfileDataFetched = (data) => {
    console.log(data);

  };


  return (
    <>
      <Header>
        <Auth onProfileDataFetched={handleProfileDataFetched} />
        <div className="main-content app-content" >
          <div className="container-fluid">
            {/* Page Header */}
            <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
              <div>
                <h4 className="mb-0">Hi, welcome back!</h4>

              </div>
            </div>
            {/* End Page Header */}
            {/* row */}
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">TOTAL USER</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              {totalUser || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">ACTIVE USER</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {activeUser || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL DEPOSIT</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            ${Number(totalDeposit || 0).toFixed(2)}
                          </h4>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-warning-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WITHDRAW </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            ${Number(totalWithdraw || 0).toFixed(2)}
                          </h4>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline4" />
                </div>
              </div>
            </div>
            {/* row closed */}
            {/* row opened */}

            <div className="row">
              <div className="mt-3 mb-3">
            
             <h5>Wallet Details</h5>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">TOTAL INCOME</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.total_income || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">AVAILABLE AMOUNT</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.total_available || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-danger-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">MAP AMOUNT</h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {walletData?.total_map_amount || '0'}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline2" />
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <div className="card overflow-hidden sales-card bg-success-gradient">
                  <div className="px-3 pt-3  pb-2 pt-0">
                    <div>
                      <h6 className="mb-3 fs-12 text-fixed-white">MAP TOKEN </h6>
                    </div>
                    <div className="pb-0 mt-0">
                      <div className="d-flex">
                        <div>
                          <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                            {Number(walletData?.total_map_token || 0).toFixed(2)}
                          </h4>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="compositeline3" />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">DIRECT INCOME</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.direct_income || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">POOL INCOME</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.pool_income || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">LEVEL INCOME</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.level_income || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-xm-12">
                <a href="/Clients">
                  <div className="card overflow-hidden sales-card bg-primary-gradient">
                    <div className="px-3 pt-3  pb-2 pt-0">
                      <div>
                        <h6 className="mb-3 fs-12 text-fixed-white">PACKAGE ROI</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <div>
                            <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                              $ {walletData?.stake_income || '0'}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div id="compositeline" />
                  </div>
                </a>
              </div>
             
            </div>

            {/* row closed */}
            {/* row opened */}
            <div className="row">
              <div className="col-xl-6 col-md-12 col-lg-12">
                <div className="card overflow-hidden">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recent User</h3>
                  </div>
                  <div className=" card-body">
                    <div className="card-body p-0 customers mt-1">
                      {tabelLoading ? (



                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>

                              <th className="wd-lg-25p">Name</th>
                              <th className="wd-lg-25p">Email</th>
                              <th className="wd-lg-25p">Join Date</th>
                            </tr>
                          </thead>

                          <tbody>
                            {recentUser.length > 0 ? (
                              recentUser.map((users, index) => (
                                <tr key={index}>
                                  <td> {users.name || 'N/A'} </td>
                                  <td> {users.email || '0'} </td>
                                  <td>
                                    {users.created_at
                                      ? new Date(users.created_at).toLocaleString()
                                      : '0'}
                                  </td>

                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-lg-6">
                <div className="card">
                  <div className="card-header pb-1">
                    <h3 className="card-title mb-2">Recentaly Deposit</h3>
                  </div>
                  <div className=" card-body">
                    <div className="card-body p-0 customers mt-1">
                      {tabelLoading ? (



                        <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >

                          <thead>
                            <tr>
                              <th className="wd-lg-25p">Asset</th>
                              <th className="wd-lg-25p">Amount</th>
                              <th className="wd-lg-25p">Status</th>
                            </tr>
                          </thead>

                          <tbody>
                            {recentDeposit.length > 0 ? (
                              recentDeposit.map((deposit, index) => (
                                <tr key={index}>
                                  <td> {deposit.deposit_asset || 'N/A'} </td>
                                  <td> {deposit.paid_amount || '0'} </td>
                                  <td> {deposit.status || 'N/A'} </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Data Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                      ) : (
                        <div className="text-center">
                          <div class="d-flex justify-content-center mb-4">
                            <div class="spinner-border" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                  </div>

                </div>
              </div>
            </div>

              <div className="row">
              <div className="col-md-12 col-lg-12 col-xl-12">
                <div className="card card-table">
                  <div className=" card-header p-0 d-flex justify-content-between mt-3">
                    <h3 className="card-title mb-1 text-primary">Recent Withdraw </h3>
                  </div>
                  <div className="table-responsive country-table">
                  {tabelLoading ? (
                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3" >
                    
                      <thead>
                        <tr>
                          <th className="wd-lg-25p">Name</th>
                          <th className="wd-lg-25p">Withdraw Amount</th>
                          <th className="wd-lg-25p">To Address</th>
                          <th className="wd-lg-25p">Txn Hash</th>
                          <th className="wd-lg-25p">Status</th>
                          <th className="wd-lg-25p">Date Time</th>
                        </tr>
                      </thead>
                     
                        <tbody>
                        {recentWithdraw.length > 0 ? (
                            recentWithdraw.map((dataClient, index) => (
                            <tr key={index}>
                                <td>{dataClient.user.name || 'N/A'}</td>
                                  <td>$ {dataClient.withdraw_amount || 'N/A'}</td>

                                  <td> {dataClient.to_address || 'N/A'} </td>
                                <td> {dataClient.txn_hash || '0'} </td>
                                 <td> {dataClient.status || 'N/A'} </td>
                                <td> {dataClient.date_time || 'N/A'} </td>
                       
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td>No Data Found</td>
                            </tr>
                        )}
                    </tbody>
                    </table>
                      ):(
                        <div className="text-center">
                             <div class="d-flex justify-content-center mb-4">
                                  <div class="spinner-border" role="status">
                                      <span class="visually-hidden">Loading...</span>
                                  </div>
                              </div>
                            </div>
                      )}
                      
                    
                  </div>
                </div>
              </div>
            </div>
            {/* row close */}
          </div>
        </div>
      </Header>

      <Footer />

    </>
  )
}

export default Index